// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__29xon"};